import { keepPreviousData, useQuery } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { MarketShopInventoryTag } from '@/models'

export type GetMarketShopInventoryTagsRequest = {
  buildingId?: number
}

export type GetMarketShopInventoryTagsResponse = MarketShopInventoryTag[]

export const GET_MARKET_SHOP_INVENTORY_TAGS_BASE_QUERY_KEY = 'useGetMarketShopInventoryTags'

export const getMarketShopInventoryTagsQueryKey = (data: GetMarketShopInventoryTagsRequest) => [
  GET_MARKET_SHOP_INVENTORY_TAGS_BASE_QUERY_KEY,
  data,
]

export const getMarketShopInventoryTags = async (
  data: GetMarketShopInventoryTagsRequest,
): Promise<GetMarketShopInventoryTagsResponse> => {
  const response = await authAPI.get('/market-shop/tags', {
    params: data,
  })
  return response.data
}

export const useGetMarketShopInventoryTags = (data: GetMarketShopInventoryTagsRequest) => {
  return useQuery({
    enabled: !!data.buildingId,
    gcTime: 0,
    placeholderData: keepPreviousData,
    queryFn: () => getMarketShopInventoryTags(data),
    queryKey: getMarketShopInventoryTagsQueryKey(data),
  })
}
